import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
// -------------------------------------------------------------
// -------------------------------------------------------------

const ParameterSummary = ({ parameterIDs }) => {
  const project = useSelector((state) => state.project);
  const [parameters, setParameters] = useState([]);

  useEffect(() => {
    if (project && project.parameters) {
      const parametersNested = project.parameters.linear.map((item) => {
        const subarray = item.entries.filter((entry) =>
          parameterIDs.includes(entry.id)
        );
        return subarray;
      });
      const parametersFlat = parametersNested.flat();
      setParameters(parametersFlat);
    }
  }, [project, parameterIDs]);

  if (!parameters || parameters.length === 0) return null;

  return (
    <div className="box">
      <table className="table is-fullwidth is-striped is-narrow">
        <tbody>
          <tr>
            <td>Reference Date</td>
            <td>{project.parameters.referenceDate}</td>
          </tr>
        </tbody>
      </table>
      <table className="table is-fullwidth is-striped is-narrow">
        <thead>
          <tr>
            <th>Parameter</th>
            <th>Value</th>
            <th>Unit</th>
            <th>Default</th>
          </tr>
        </thead>
        <tbody>
          {parameters.map((parameter) => {
            if (parameter.type === "array") {
              return (
                <tr key={parameter.id}>
                  <td>{parameter.text}</td>
                  <td colSpan={3}>
                    <div className="tags">
                      {parameter.value.map((item) => (
                        <div key={item} className="tag is-info is-light">
                          {item}
                        </div>
                      ))}
                    </div>
                  </td>
                </tr>
              );
            }
            return (
              <tr key={parameter.id}>
                <td>{parameter.text}</td>
                <td>{parameter.value}</td>
                <td>{parameter.unit}</td>
                <td>{parameter.defaultValue}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default ParameterSummary;
